import { Divider, Typography, useTheme } from "@material-ui/core";
import { get } from "lodash";
import React from "react";
import { useTranslate } from "react-admin";
const PaymentInfoField = ({ record, source }) => {
	const theme = useTheme();
	const translate = useTranslate();
	const isTotal = get(record, "is_total");
	if (isTotal) {
		return null;
	}
	const data = JSON.parse(get(record, source));
	const method = JSON.parse(get(record, "method.config", "{}"));
	if (data === null) {
		return (
			<Typography variant="body2" color="textSecondary">
				{translate("resources.user-payments.no_payment_method_info")}
			</Typography>
		);
	}
	const keys = Object.keys(data).sort();
	const taxType = get(record, "tax_type", "person");
	const eInvoice = get(record, "user.profile.e_invoice");
	const withholdingTaxReturn = get(record, "withholding_tax_return");
	return (
		<React.Fragment>
			<Typography variant="body2">
				<strong>
					{translate("resources.payment-methods.name")}:{" "}
					{get(record, "method.name", "NA")}
				</strong>
				{keys
					// .filter((key) => key !== "email")
					.filter((key) => get(method, key) !== undefined)
					.map((key) => (
						<span key={key} style={{ display: "block", clear: "both" }}>
							<strong>
								{translate(
									`ra.profile.fields.${
										key.startsWith(".") ? key.substr(1) : key
									}`
								)}
								{": "}
								{/* ({key}) : */}
							</strong>{" "}
							{data[key]}{" "}
						</span>
					))}
			</Typography>
			<Divider
				style={{
					marginTop: theme.spacing(1),
					marginBottom: theme.spacing(1),
					width: "50%",
				}}
			/>
			<Typography variant="body2">
				<span style={{ display: "block", clear: "both" }}>
					<strong>
						{translate("resources.users.fields.profile.tax_type")}
					</strong>{" "}
					{translate(`resources.profiles.tax_type.${taxType}`)}
				</span>
				{taxType === "person" && (
					<span style={{ display: "block", clear: "both" }}>
						<strong>
							{translate(
								"resources.user-payments.fields.withholding_tax_return"
							)}
							{": "}
						</strong>
						{withholdingTaxReturn
							? translate("ra.action.yes")
							: translate("ra.action.no")}
					</span>
				)}
				{taxType === "company" && (
					<span style={{ display: "block", clear: "both" }}>
						<strong>
							{translate("resources.users.fields.profile.e_invoice")}
						</strong>
						{": "}
						{eInvoice ? translate("ra.action.yes") : translate("ra.action.no")}
					</span>
				)}
			</Typography>
		</React.Fragment>
	);
};

export default PaymentInfoField;
